module.exports = __webpack_public_path__ + "media/logos/law.com-logo-black-2c159432.png";